import { render, staticRenderFns } from "./recordExchange.vue?vue&type=template&id=3294ff14&scoped=true&"
import script from "./recordExchange.vue?vue&type=script&lang=js&"
export * from "./recordExchange.vue?vue&type=script&lang=js&"
import style0 from "./recordExchange.vue?vue&type=style&index=0&id=3294ff14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294ff14",
  null
  
)

export default component.exports